import { fetchCalendarActivities } from "@/data/calendar.api";
import { fetchChartData } from "@/data/chart.api";
import { fetchMapActivities } from "@/data/map.api";
import { fetchTableActivities } from "@/data/table.api";
import type { DataClient } from "@/types/client.types";

export const authedClient: DataClient = {
  fetchTableActivities,
  fetchChartData,
  fetchCalendarActivities,
  fetchMapActivities,
};
